module.exports = __webpack_public_path__ + "static/media/penguin_boofi_ghoul.3fb4e9e0.jpg";